import React, { memo, HTMLProps } from 'react';
import classnames from 'classnames';
import styles from './list.module.scss';
import Element from '../../element';
interface IProps extends HTMLProps<HTMLLIElement> {
    className?: string;
    children: React.ReactNode;
    active?: boolean;
}

const ListItem = React.forwardRef((props: IProps, ref: any) => {
    const { className, children, active, ...rest } = props;
    return (
        <Element
            {...rest}
            domRef={ref}
            className={classnames(styles['item-list'], className, {
                [styles['is-active']]: active,
            })}
        >
            {children}
        </Element>
    );
});

export default memo(ListItem);
